import { css } from '@emotion/react'
import { IconSize } from './Icon'

type IconContainerProps = {
  colour: string
  size: IconSize
  fillColour?: string
  selected?: boolean
  selectedColour?: string
  accentColour?: string
  bgColour?: string
}

const getIconSize = (size: IconSize) => {
  switch (size) {
    case 'small':
      return '16px'
    case 'medium':
      return '20px'
    case 'large':
      return '33px'
    case 'fit':
      return '100%'
    default:
      return '24px'
  }
}

export const iconContainer = ({
  colour,
  size,
  fillColour,
  selected = false,
  selectedColour,
  accentColour,
  bgColour,
}: IconContainerProps) => css`
  width: ${getIconSize(size)};
  height: ${getIconSize(size)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  color: ${selected ? (selectedColour ?? colour) : colour};
  fill: ${fillColour && (selected ? (selectedColour ?? colour) : colour)};

  /* CSS variables for multi-colour for new sidebar icons */
  --icon-fg: ${selected ? (selectedColour ?? colour) : colour};
  --icon-accent: ${accentColour ?? 'currentColor'};
  --icon-bg: ${bgColour ?? 'transparent'};
  --icon-selected: ${selected ? 1 : 0};
`
